import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Helmet } from "react-helmet";
import "./App.css";
import NavBar from './components/NavBar';
import PrivacyPolicy from './components/PrivacyPolicy';
import ContentPolicy from './components/ContentPolicy';
import TermsCondition from './components/TermsofService';
import Disclaimer from './components/Disclaimer';
import Contact from './components/Contact';
import About from './components/About'
import CookiePolicy from './components/CookiePolicy';
import Home from './components/Home';
import Footer from './components/Footer';
import CreditCardPayoffCalculator from './components/Pages/CreditCardPayoffCalculator';
import PaymentInterestCalculator from './components/Pages/PaymentInterestCalculator';
import CreditCardInterestCalculator from './components/Pages/CreditCardInterestCalculator';
import BalanceTransferCalculator from './components/Pages/BalanceTransferCalculator';
import CashbackRewardsCalculator from './components/Pages/CashbackRewardsCalculator';
import CreditLimitIncreaseEstimator from './components/Pages/CreditLimitIncreaseEstimator';
import CreditUtilizationCalculator from './components/Pages/CreditUtilizationCalculator';
import DTICalculator from './components/Pages/DTICalculator';
import CardApprovalOddsChecker from './components/Pages/CardApprovalOddsChecker';
import CreditCardUpgradeAnalyzer from './components/Pages/CreditCardUpgradeAnalyzer';
import AnnualFeeValueCalculator from './components/Pages/AnnualFeeValueCalculator';

function App() {
  return (
    <>
      <BrowserRouter>
        <NavBar />
        <div className="pages">
          <Routes>
          <Route
  path="/"
  element={
    <>
      <Helmet>
        <title>CreditsIQ - Smart Credit Calculators & Financial Tools</title>
        <meta
          name="description"
          content="Access free credit and finance tools by CreditsIQ. Calculate credit scores, loan payments, EMIs, interest rates, and more with accurate online calculators."
        />
        <meta
          name="keywords"
          content="credit calculator, loan calculator, EMI calculator, interest calculator, finance tools, CreditsIQ"
        />
      </Helmet>
      <Home />
    </>
  }
/>

<Route
  path="/Contact"
  element={
    <>
      <Helmet>
        <title>Contact CreditsIQ | Get in Touch</title>
        <meta
          name="description"
          content="Have questions or feedback? Contact CreditsIQ for support, inquiries, or partnerships. We’re here to help you with our credit and finance tools."
        />
        <meta
          name="keywords"
          content="contact CreditsIQ, CreditsIQ support, contact us, financial tools help"
        />
      </Helmet>
      <Contact />
    </>
  }
/>

<Route
  path="/CookiePolicy"
  element={
    <>
      <Helmet>
        <title>Cookie Policy | CreditsIQ</title>
        <meta
          name="description"
          content="Read CreditsIQ’s Cookie Policy to learn how we use cookies to enhance user experience and improve our financial tools."
        />
        <meta
          name="keywords"
          content="cookie policy, CreditsIQ cookies, website cookies"
        />
      </Helmet>
      <CookiePolicy />
    </>
  }
/>

<Route
  path="/PrivacyPolicy"
  element={
    <>
      <Helmet>
        <title>Privacy Policy | CreditsIQ</title>
        <meta
          name="description"
          content="Learn how CreditsIQ collects, uses, and protects your personal data. Your privacy is important to us."
        />
        <meta
          name="keywords"
          content="privacy policy, data protection, CreditsIQ privacy"
        />
      </Helmet>
      <PrivacyPolicy />
    </>
  }
/>

<Route
  path="/Disclaimer"
  element={
    <>
      <Helmet>
        <title>Disclaimer | CreditsIQ</title>
        <meta
          name="description"
          content="Read the official disclaimer from CreditsIQ regarding accuracy, financial advice, and liability related to our calculators and tools."
        />
        <meta
          name="keywords"
          content="CreditsIQ disclaimer, financial disclaimer, calculator accuracy"
        />
      </Helmet>
      <Disclaimer />
    </>
  }
/>

<Route
  path="/TermsCondition"
  element={
    <>
      <Helmet>
        <title>Terms & Conditions | CreditsIQ</title>
        <meta
          name="description"
          content="Review CreditsIQ’s Terms and Conditions for using our calculators and financial tools responsibly."
        />
        <meta
          name="keywords"
          content="terms and conditions, CreditsIQ terms, finance terms"
        />
      </Helmet>
      <TermsCondition />
    </>
  }
/>

<Route
  path="/ContentPolicy"
  element={
    <>
      <Helmet>
        <title>Content Policy | CreditsIQ</title>
        <meta
          name="description"
          content="Understand CreditsIQ’s Content Policy on user-generated content, usage rights, and responsible publishing."
        />
        <meta
          name="keywords"
          content="content policy, CreditsIQ content rules, user content guidelines"
        />
      </Helmet>
      <ContentPolicy />
    </>
  }
/>

<Route
  path="/About"
  element={
    <>
      <Helmet>
        <title>About CreditsIQ | Smart Credit Tools for Everyone</title>
        <meta
          name="description"
          content="CreditsIQ provides simple, accurate credit and finance tools to help you make informed financial decisions. Learn more about us."
        />
        <meta
          name="keywords"
          content="about CreditsIQ, CreditsIQ tools, credit score tools"
        />
      </Helmet>
      <About />
    </>
  }
/>

<Route
  path="/CreditCardPayoffCalculator"
  element={
    <>
      <Helmet>
        <title>Credit Card Payoff Calculator | CreditsIQ</title>
        <meta
          name="description"
          content="Calculate how long it will take to pay off your credit cards and plan your payments efficiently with CreditsIQ."
        />
        <meta
          name="keywords"
          content="credit card payoff calculator, debt payoff, CreditsIQ"
        />
      </Helmet>
      <CreditCardPayoffCalculator />
    </>
  }
/>

<Route
  path="/PaymentInterestCalculator"
  element={
    <>
      <Helmet>
        <title>Payment Interest Calculator | CreditsIQ</title>
        <meta
          name="description"
          content="Estimate interest on your payments and see how much you’ll pay over time with CreditsIQ's Payment Interest Calculator."
        />
        <meta
          name="keywords"
          content="payment interest calculator, interest estimation, CreditsIQ"
        />
      </Helmet>
      <PaymentInterestCalculator />
    </>
  }
/>

<Route
  path="/CreditCardInterestCalculator"
  element={
    <>
      <Helmet>
        <title>Credit Card Interest Calculator | CreditsIQ</title>
        <meta
          name="description"
          content="Quickly calculate interest charges on your credit cards and manage your finances better with CreditsIQ."
        />
        <meta
          name="keywords"
          content="credit card interest calculator, credit card interest, CreditsIQ"
        />
      </Helmet>
      <CreditCardInterestCalculator />
    </>
  }
/>

<Route
  path="/BalanceTransferCalculator"
  element={
    <>
      <Helmet>
        <title>Balance Transfer Calculator | CreditsIQ</title>
        <meta
          name="description"
          content="Calculate potential savings from balance transfers and optimize your credit card strategy with CreditsIQ."
        />
        <meta
          name="keywords"
          content="balance transfer calculator, credit card balance, CreditsIQ"
        />
      </Helmet>
      <BalanceTransferCalculator />
    </>
  }
/>

<Route
  path="/CashbackRewardsCalculator"
  element={
    <>
      <Helmet>
        <title>Cashback Rewards Calculator | CreditsIQ</title>
        <meta
          name="description"
          content="Estimate how much cashback you can earn with your credit cards using CreditsIQ's Cashback Rewards Calculator."
        />
        <meta
          name="keywords"
          content="cashback rewards calculator, credit card rewards, CreditsIQ"
        />
      </Helmet>
      <CashbackRewardsCalculator />
    </>
  }
/>

<Route
  path="/CreditLimitIncreaseEstimator"
  element={
    <>
      <Helmet>
        <title>Credit Limit Increase Estimator | CreditsIQ</title>
        <meta
          name="description"
          content="Estimate potential credit limit increases and plan your spending effectively with CreditsIQ."
        />
        <meta
          name="keywords"
          content="credit limit increase, estimator, CreditsIQ"
        />
      </Helmet>
      <CreditLimitIncreaseEstimator />
    </>
  }
/>

<Route
  path="/CreditUtilizationCalculator"
  element={
    <>
      <Helmet>
        <title>Credit Utilization Calculator | CreditsIQ</title>
        <meta
          name="description"
          content="Monitor your credit utilization ratio and improve your credit score using CreditsIQ's calculator."
        />
        <meta
          name="keywords"
          content="credit utilization calculator, credit score, CreditsIQ"
        />
      </Helmet>
      <CreditUtilizationCalculator />
    </>
  }
/>

<Route
  path="/DTICalculator"
  element={
    <>
      <Helmet>
        <title>Debt-to-Income (DTI) Calculator | CreditsIQ</title>
        <meta
          name="description"
          content="Calculate your debt-to-income ratio and better understand your financial health with CreditsIQ."
        />
        <meta
          name="keywords"
          content="DTI calculator, debt-to-income, CreditsIQ"
        />
      </Helmet>
      <DTICalculator />
    </>
  }
/>

<Route
  path="/CardApprovalOddsChecker"
  element={
    <>
      <Helmet>
        <title>Card Approval Odds Checker | CreditsIQ</title>
        <meta
          name="description"
          content="Estimate your chances of credit card approval and make informed decisions with CreditsIQ."
        />
        <meta
          name="keywords"
          content="card approval checker, credit card approval, CreditsIQ"
        />
      </Helmet>
      <CardApprovalOddsChecker />
    </>
  }
/>

<Route
  path="/CreditCardUpgradeAnalyzer"
  element={
    <>
      <Helmet>
        <title>Credit Card Upgrade Analyzer | CreditsIQ</title>
        <meta
          name="description"
          content="Analyze potential credit card upgrades and benefits to find the best option with CreditsIQ."
        />
        <meta
          name="keywords"
          content="credit card upgrade, analyzer, CreditsIQ"
        />
      </Helmet>
      <CreditCardUpgradeAnalyzer />
    </>
  }
/>

<Route
  path="/AnnualFeeValueCalculator"
  element={
    <>
      <Helmet>
        <title>Annual Fee Value Calculator | CreditsIQ</title>
        <meta
          name="description"
          content="Determine if your credit card's annual fee is worth it using CreditsIQ's Annual Fee Value Calculator."
        />
        <meta
          name="keywords"
          content="annual fee calculator, credit card fee, CreditsIQ"
        />
      </Helmet>
      <AnnualFeeValueCalculator />
    </>
  }
/>
          </Routes>
        </div>
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;